import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "q-py-sm q-px-md text-white bg-primary" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "q-px-md q-py-md text-off-black" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 3,
  class: "row"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Bulk updates have been applied", -1)
const _hoisted_11 = {
  key: 0,
  class: "q-ml-xs"
}
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { class: "q-mr-xs" }
const _hoisted_14 = { class: "absolute-full flex flex-center" }
const _hoisted_15 = {
  key: 0,
  class: "relative"
}

import { storeToRefs } from 'pinia';
import { useDialogPluginComponent } from 'quasar';
import { ref, Ref, computed, onUnmounted } from 'vue';
import { useDeviceStore } from '#src/store/device';
import useSetTimeout from 'composables/set-timeout';
import useWebsocket from 'composables/websocket';
import ErrorBanner from 'components/ErrorBanner.vue';
import InfoBanner from 'components/InfoBanner.vue';
import ScrollArea from 'components/ScrollArea.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkExecutionDialog',
  props: {
    bulkExecutionId: null,
    serials: null,
    updates: null
  },
  setup(__props: any) {

const props = __props as { bulkExecutionId: string; serials: string[]; updates: BulkUpdatePayload };



const { dialogRef } = useDialogPluginComponent();

const deviceStore = useDeviceStore();

const { ws } = useWebsocket();

const wait = useSetTimeout();

const applying = ref(false);
const emailError = ref('');
const finished = ref(false);
const initError = ref('');
const results: Ref<{ serial: string; success: boolean; error?: string }[]> = ref([]);

const errors = computed(() => results.value.filter((result) => result.success === false));

const progressColor = computed(() => {
  if (errors.value.length) {
    if (errors.value.length === props.serials.length) {
      return 'negative';
    }
    return 'warning';
  }
  if (finished.value) {
    return 'positive';
  }
  return 'primary';
});

function onEmailError(payload: unknown) {
  const bulkUpdateProgress = <{ bulkExecutionId: string; error: string }>payload;
  if (bulkUpdateProgress.bulkExecutionId !== props.bulkExecutionId) {
    return;
  }
  emailError.value = bulkUpdateProgress.error;
}

function onProgress(payload: unknown) {
  const bulkUpdateProgress = <BulkUpdateProgressPayload>payload;
  if (bulkUpdateProgress.bulkExecutionId !== props.bulkExecutionId) {
    return;
  }
  results.value = bulkUpdateProgress.results;
}

async function onFinish(payload: unknown) {
  const bulkUpdateProgress = <BulkUpdateProgressPayload>payload;
  if (bulkUpdateProgress.bulkExecutionId !== props.bulkExecutionId) {
    return;
  }
  onProgress(payload);
  ws.off('bulk-update/progress', onProgress);
  ws.off('bulk-update/email-error', onEmailError);
  ws.off('bulk-updates/finished', onFinish);
  applying.value = false;
  finished.value = true;
}

async function applyUpdates() {
  initError.value = '';
  applying.value = true;
  finished.value = false;

  ws.on('bulk-update/progress', onProgress);
  ws.on('bulk-update/email-error', onEmailError);
  ws.on('bulk-updates/finished', onFinish);

  const { error } = await deviceStore.applyBulkUpdates(props.serials, props.updates, props.bulkExecutionId);

  if (error) {
    initError.value = error;
    onFinish(results.value);
    finished.value = false;
  }
}

onUnmounted(() => {
  if (applying.value) {
    onFinish(results.value);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"min-width":"400px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title q-pa-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (!applying.value && !finished.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Confirm Bulk Update"))
                  : (applying.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Applying Bulk Update"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, "Bulk Update Finished"))
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            (!applying.value && !finished.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createTextVNode(" You are about to apply the following change to "),
                  _createElementVNode("strong", null, _toDisplayString(__props.serials.length), 1),
                  _createTextVNode(" devices. Press \"Continue\" to begin the bulk update. ")
                ]))
              : (!finished.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, " The bulk update is being applied. An email will be sent to you once this process is complete. You can also keep this dialog open for live progress. "))
                : (_unref(errors).length === results.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, "All updates have failed."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      (_unref(errors).length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "with " + _toDisplayString(_unref(errors).length) + " error" + _toDisplayString(_unref(errors).length === 1 ? '' : 's'), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" . ")
                    ])),
            (!finished.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.updates, (value, update) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: update,
                      class: "q-mt-sm"
                    }, [
                      (update === 'config')
                        ? (_openBlock(), _createBlock(InfoBanner, {
                            key: 0,
                            class: "bg-warning",
                            "hide-icon": applying.value
                          }, {
                            default: _withCtx(() => [
                              (applying.value)
                                ? (_openBlock(), _createBlock(_component_q_spinner, {
                                    key: 0,
                                    class: "q-mr-sm"
                                  }))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_13, "Chang" + _toDisplayString(applying.value ? 'ing' : 'e') + " configuration to:", 1),
                              _createElementVNode("strong", null, _toDisplayString(value), 1)
                            ]),
                            _: 2
                          }, 1032, ["hide-icon"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (initError.value)
              ? (_openBlock(), _createBlock(ErrorBanner, {
                  key: 5,
                  class: "q-mt-md"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(initError.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (emailError.value)
              ? (_openBlock(), _createBlock(ErrorBanner, {
                  key: 6,
                  class: "q-mt-md"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(emailError.value), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (applying.value)
              ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                  key: 7,
                  class: "q-mt-sm",
                  color: _unref(progressColor),
                  size: "25px",
                  value: results.value.length / __props.serials.length
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_q_badge, {
                        color: "white",
                        label: `${results.value.length} / ${__props.serials.length} Applied`,
                        "text-color": "off-black"
                      }, null, 8, ["label"])
                    ])
                  ]),
                  _: 1
                }, 8, ["color", "value"]))
              : _createCommentVNode("", true)
          ]),
          (_unref(errors).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(ScrollArea, {
                  "hide-show-more": "",
                  "max-items-shown": 3
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (result, index) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: index,
                        class: "q-py-none"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ErrorBanner, {
                            class: "full-width q-mb-xs q-mx-md",
                            message: `Failed to update ${result.serial}: ${result.error}`
                          }, null, 8, ["message"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_actions, {
            align: "right",
            class: "q-pb-md q-px-md"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, {
                color: "white",
                label: "Dismiss",
                padding: "xs md",
                "text-color": "off-black"
              }, null, 512), [
                [_directive_close_popup]
              ]),
              (!applying.value && !finished.value)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    color: "primary",
                    label: "Continue",
                    padding: "xs md",
                    onClick: applyUpdates
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})